import { withTheme } from '@digital-retail/falabella-ui-cross-components';
import PropTypes from 'prop-types';
import React from 'react';
import constants from '../../../config/constants';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import createListStyles from './CreateList.style';

const CreateList = ({ showForm, label, onClickCreateList, theme, appCtx }) => {
  const { store = '' } = appCtx;
  const themedStyles = createListStyles(theme);
  const setFormVisible = () => {
    showForm(true);
    onClickCreateList(constants.ML_METRICS.METRICS_DATA.CLICK_CREATE_LIST);
  };

  return (
    <button
      type="button"
      onClick={setFormVisible}
      className={`create-list-button ${store}`}
      id="myListCreateListButton"
    >
      <i className="csicon-add" />
      <span className="button-text">{label}</span>
      <style jsx>{themedStyles}</style>
    </button>
  );
};

CreateList.propTypes = {
  showForm: PropTypes.func.isRequired,
  label: PropTypes.string,
  onClickCreateList: PropTypes.func.isRequired,
  theme: PropTypes.shape({}).isRequired,
  appCtx: PropTypes.object.isRequired,
};

CreateList.defaultProps = {
  label: 'Crear una nueva lista',
};

export default withApplicationContext(withTheme(CreateList));
